import { render, staticRenderFns } from "./DetailTeacher.vue?vue&type=template&id=63bf7ec0"
import script from "../../services/teacher/detail-teacher.js?vue&type=script&lang=js&external"
export * from "../../services/teacher/detail-teacher.js?vue&type=script&lang=js&external"
import style0 from "../../assets/css/teacher/detail-teacher.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports